import '../sass/frontend.scss';

(function($){
    $(function(){
        function moveVideoIntoGallery() {
            const $gallery = jQuery('.woocommerce-product-gallery');
            const $videos  = jQuery('.swoo-product-videos');
            if (!$gallery.length || !$videos.length) return;
            if (!$videos.parent().hasClass('woocommerce-product-gallery')) {
                $gallery.children().last().after($videos); // insert as last child
            }
            $videos.show();
            return this;
        }
        moveVideoIntoGallery();
    })
})(jQuery);
